import TableMain from "./table-main";
import TableMainCursor from "./table-main-cursor";
import TableDragSorting from "./table-drag-sorting";
import TableMock from "./table-mock";

const Tables = {
    Main: TableMain,
    Cursor: TableMainCursor,
    DragSorting: TableDragSorting,
    Mock: TableMock,
};

export default Tables;
